module.exports = __webpack_public_path__ + "img/SES_191418802.742b9797.jpg";